const GlobalTranslations = {
  'more':             'More',
  'less':             'Less',
  'positive':         'Positive',
  'negative':         'Negative',
  'failed_to_upload': {
    'image': 'Your image failed to upload. Please try again or contact our support'
  },
  'user_attributes':  {
    'skills':      'Skills',
    '3d_software': '3D Software'
  },
  'titles':           {
    '3d_projects': '3D Projects',
    '3d_models':   '3D Models'
  },
  'no_3d_projects_accepted': 'This designer does not accept custom 3D Project requests'
}

export default GlobalTranslations
